import { ref } from 'vue';

const isCouponRewardDialogShow = ref(false);

/** 迎新券弹层hook */
export const useCouponRewardDialog = () => {
  // 展示迎新券弹层
  function showCouponRewardDialog() {
    isCouponRewardDialogShow.value = true;
  }
  // 隐藏迎新券弹层
  function hideCouponRewardDialog() {
    isCouponRewardDialogShow.value = false;
  }
  return {
    /** 是否展示迎新券弹层 */
    isCouponRewardDialogShow,

    /** 展示迎新券弹层 */
    showCouponRewardDialog,
    /** 隐藏迎新券弹层 */
    hideCouponRewardDialog,
  };
};
